<template>
  <NcrmRecordEditDialog
    :model-value="modelValue"
    :title="title"
    :subtitle="subtitle"
    :loading="loading"
    :save-label="saveLabel"
    :max-width="520"
    @update:model-value="emitModelValue"
    @save="$emit('confirm')"
  >
    <div class="d-grid ga-4">
      <v-alert v-if="message" type="info" density="comfortable" class="mb-0">
        {{ message }}
      </v-alert>

      <div class="d-grid ga-3">
        <div>
          <div class="text-caption text-medium-emphasis">{{ recordFieldLabel }}</div>
          <div class="text-body-2 ncrm-text-strong">{{ entityName || emptyValueLabel }}</div>
        </div>

        <div>
          <div class="text-caption text-medium-emphasis">{{ ownerFieldLabel }}</div>
          <div class="text-body-2">{{ currentOwnerLabel || emptyValueLabel }}</div>
        </div>
      </div>
    </div>
  </NcrmRecordEditDialog>
</template>

<script>
import NcrmRecordEditDialog from "@/components/ncrm/shared/NcrmRecordEditDialog.vue";

export default {
  name: "NcrmOwnerClaimDialog",
  components: {
    NcrmRecordEditDialog,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    recordFieldLabel: {
      type: String,
      default: "",
    },
    entityName: {
      type: String,
      default: "",
    },
    ownerFieldLabel: {
      type: String,
      default: "",
    },
    currentOwnerLabel: {
      type: String,
      default: "",
    },
    emptyValueLabel: {
      type: String,
      default: "-",
    },
    saveLabel: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "confirm"],
  methods: {
    emitModelValue(value) {
      this.$emit("update:modelValue", Boolean(value));
    },
  },
};
</script>
